import SnackbarMui, { SnackbarProps } from "@mui/material/Snackbar"
import "./index.scss"

export const Snackbar = (props: SnackbarProps) => (
  <SnackbarMui className="snackbar" {...props} />
)
